<template>
  <div class="aside-order-help-component">
    <div class="flex align-start">
      <font-awesome-icon icon="headset" />
      <span class="help-text">Здравствуйте, доставка Сушифокс! Меня зовут @Олег, как могу к вам
        обращаться?</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OrderHelp',
    props: {
      text: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="less" scoped>
.aside-order-help-component {
  position: relative;
  margin-top: 25px;
  margin-bottom: 30px;
  background-color: #fff3d6;
  border-radius: 10px;
  padding: 21px 12px 13px;
  z-index: 0;
  &:after {
    content: '';
    position: absolute;
    left: 5px;
    top: -10px;
    border: 12px solid;
    border-color: transparent #fff3d6 transparent transparent;
  }
  svg {
    width: 25px;
    height: 25px;
    margin-right: 21px;
    font-size: 16px;
    line-height: 19px;
    .fill-svg(#E1CD9D);
  }
}
</style>
